"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useActions(query) {
  const { ...rest } = useElements("actions", query);
  return {
    actions: rest.items,
    ...rest
  };
}

export { useActions };
